import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../colorVars';

export function GapMarkers({ gaps, scaleX, size, bottomPadding }) {
  if (!gaps?.length || !scaleX) return null;

  return (
    <g>
      {gaps.map(({ slotIndex, startTimeStamp, endTimeStamp }) => {
        const leftX = scaleX(slotIndex);
        const rightX = scaleX(slotIndex + 1);
        const width = Math.max(rightX - leftX, 0);
        const centerX = leftX + width / 2;

        return (
          <g key={`${startTimeStamp}-${endTimeStamp}`}>
            <rect
              x={leftX}
              y={0}
              width={width}
              height={size + bottomPadding}
              fill={colors.white}
              opacity={0.07}
            />
            <line
              x1={leftX}
              x2={leftX}
              y1={0}
              y2={size + bottomPadding}
              stroke={colors.white}
              strokeOpacity={0.25}
              strokeDasharray="4,4"
            />
            <line
              x1={rightX}
              x2={rightX}
              y1={0}
              y2={size + bottomPadding}
              stroke={colors.white}
              strokeOpacity={0.25}
              strokeDasharray="4,4"
            />
            <text
              x={centerX}
              y={size / 2}
              textAnchor="middle"
              fill={colors.white}
              strokeWidth={0}
              style={{ fontSize: '18px', fontWeight: 700, opacity: 0.9 }}
            >
              …
            </text>
          </g>
        );
      })}
    </g>
  );
}

GapMarkers.propTypes = {
  bottomPadding: PropTypes.number,
  gaps: PropTypes.array,
  scaleX: PropTypes.func,
  size: PropTypes.number,
};
